// React
import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

// Appt
import Box from '../../simple/box/Box.js'
import Text from '../../simple/text/Text.js'
import styled from 'styled-components'

/**
 * `SimpleCounter` renders a Card to display a counter of items eg. number of posts
 */

  const StyledBox = styled(Box)`
    border: 2px solid #04124C;
  `
  const StyledBoxHover = styled(Box)`
    border: 2px solid #04124C;
    &:hover {
        border: 2px solid #ff8300;
    }
  `

  const StyledText = styled(Text)`
    text-decoration: none;
  `

  const StyledTextHover = styled(Text)`
    text-decoration: none;

    .simple-counter-small:hover &, &:focus, &:hover, &:visited, &:link, &:active, &:is(:hover) {
        text-decoration: none;
        color: #ff8300 !important;
    }

    &:hover:not(:first-child) {
      // background: #c34a36;
    }
  `

function SimpleCounter (props) {
  const [count, setCount] = useState(0)

  useEffect(() => {
    let start = 0

    // first three numbers from props
    const end = parseInt(props.count.substring(0, 3))

    // if zero, return
    if (start === end) return

    // find duration per increment
    const totalMilSecDur = parseInt(props.duration || 1)
    const incrementTime = (totalMilSecDur / end) * 1000

    const timer = setInterval(() => {
      start += 1
      setCount(String(start) + props.count.substring(3))
      if (start === end) clearInterval(timer)
    }, incrementTime)
  }, [props.count, props.duration])

  let boxStyle = {}
  let hasOnClick = false

  if (props?.onClick) {
    hasOnClick = true
  }

  let StyledBoxComponent = hasOnClick ? StyledBoxHover : StyledBox
  let StyledTextComponent = hasOnClick ? StyledTextHover : StyledText


  return (
    <StyledBoxComponent
      align='center'
      background={props.background || '#fff'}
      pad='medium'
      round='small'
      direction='row'
      gap='small'
      sx={ props?.boxStyle }
      onClick={props.onClick}
      // animation='fadeIn'
      hoverIndicator={{
          color: 'besmartBlue', cursor: 'pointer'
      }}
      className="simple-counter-small"
    >
      <StyledTextComponent color='brand' size='64px' weight={600}>{count}</StyledTextComponent>
      <StyledTextComponent color='#000' size='medium' weight={400}>{props.label}</StyledTextComponent>
    </StyledBoxComponent>)
}

SimpleCounter.propTypes = {
  /**
   * Either a color identifier to use for the background color.
   * For example: 'neutral-1'. Or, a 'url()' for an image. Dark is not needed if color is provided.
   *
   * "neutral-1"
   * "url(//my.com/assets/img.png)"
   * {
   * &nbsp;"color": "neutral-1",
   * &nbsp;"dark": true,
   * &nbsp;"opacity": true,
   * &nbsp;"position": "bottom",
   * &nbsp;"repeat": "no-repeat",
   * &nbsp;"size": "cover",
   * &nbsp;"image": "url(//my.com/assets/img.png)"
   * }
   * {"dark": "light-2", "light": "dark-2"}
   *
   * where opacity could be:
   *  &nbsp;"weak"
   *  &nbsp;"medium"
   *  &nbsp;"strong"
   *  &nbsp;true
   *
   * where position could be:
   *  &nbsp;any CSS for background-position
   *
   * where repeat could be:
   *  &nbsp;"no-repeat"
   *  &nbsp;"repeat"
   *  &nbsp;"string"
   *
   * where size could be:
   *  &nbsp;"cover"
   *  &nbsp;"contain"
   *  &nbsp;"string"
   */
  background: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ])
}

export default SimpleCounter




